import type { PropsWithChildren } from 'react'

export interface ParametersProps {
  title: string
  linkToDocs?: string
}
export const Parameters: React.FC<PropsWithChildren<ParametersProps>> = ({
  children,
}) => {
  return (
    <div className="no-text-padding group pb-2 pt-6">
      <div className="w-full overflow-hidden rounded-sm border border-neutral-subtle">
        <table className="w-full table-fixed text-left">
          <thead className="w-full">
            <tr className="w-full border-b border-neutral-subtle bg-primary">
              <th className="w-1/4 px-6 py-3">Term</th>
              <th className="w-3/4 px-6 py-3">Definition</th>
            </tr>
          </thead>
          <tbody className="w-full divide-y divide-neutral-subtle">
            {children}
          </tbody>
        </table>
      </div>
    </div>
  )
}
